import { createFileRoute } from "@tanstack/react-router";
import FAQ from "@/pages/FAQ";
import { faqPageHead } from "@/lib/route-seo";

export const Route = createFileRoute("/about/faq")({
  head: () => faqPageHead(),
  component: FAQ,
});
